// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** China */
const CN: PhoneNumberData = [86, 'CN', 11, '000 0000 0000'];

export default CN;
